export enum RouteResolverData {
  Categories = 'categories',
}
